module.exports = __webpack_public_path__ + "img/iconOffline.dd85fbc6.png";